import React, { Component, useState } from 'react'
import { connect } from "react-redux";

import {Button, Calendar, CalendarCell, CalendarGrid, DateInput, DatePicker, DateSegment, Dialog, Group, Heading, Label, Popover} from 'react-aria-components';
import {GridList, GridListItem, ComboBox, Input, ListBox, ListBoxItem} from 'react-aria-components';
import {FieldHolder} from "@/components/holders/FieldHolder";
import type {SwitchProps} from 'react-aria-components';
import { SelectBox } from "@/components/holders/SelectBox";

import moment from 'moment'
import DossierHelper from '@/helpers/DossierHelper';

import ModaBaseView from './view/ModalBase';

class ModalBase extends Component {
    constructor(props) {
        super(props);
        
        this.state = {error: null}
    }    

    render() {
        if(this.props['current']) {
        return (<>
           <ModaBaseView key={this.props['refreshKey']}  {...this.props}/>
        </>);
        }
         
         return (<></>);   
    }
}

const mapStateToProps = state => {
    const {ModalReducerClass} = state;
  return {
    current: ModalReducerClass.current,
    refreshKey: ModalReducerClass.key
  };
};

export default connect(mapStateToProps)(ModalBase);

//changeEvent={(name, selectedSector) => changeUserEventHandler(name, selectedSector)} 